import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, registerables } from "chart.js";
import { sendPostRequest } from "../../../../../actions/app-actions";
import { getAdminBusinessId } from "../../../../../utils/authHelper";
import { getLoggedInUserTimezone } from "../../../../../utils/utility";
import { connect } from "react-redux";
import { Select } from "antd";
import "bootstrap-daterangepicker/daterangepicker.css";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import Tooltip from "../../../../../components/Tooltip";

Chart.register(...registerables);

const PieSalesChart = (props) => {
  const [chartData, setChartData] = useState(null);
  const [renderChart, setRenderChart] = useState(false);
  const [eventId, setEventId] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    loadChartData();
  }, []);

  const loadChartData = (data = {}) => {
    const { sendPostRequest } = props;
    sendPostRequest({
      url: `/admin/event-availability-ratio-chart/${getAdminBusinessId()}`,
      data: {
        ...data,
        timezone: getLoggedInUserTimezone(),
      },
      onSuccess: function (response) {
        const { data: respData } = response;
        setChartData({
          labels: respData.data.map((row) => row.label),
          datasets: [
            {
              label: "Total Minutes",
              data: respData.data.map((d) => d.total),
              backgroundColor: ["#1789C6", "#FF9500", "#9270D5", "#00C875"],
              borderWidth: 0,
              hoverOffset: 6,
            },
          ],
        });
        setRenderChart(true);
      },
      onError: function (error) {
        console.log("error", error);
      },
    });
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    cutout: "65%",
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        labels: {
          padding: 16,
          usePointStyle: true,
          pointStyle: "circle",
          font: { size: 12 },
          color: "#6f767e",
        },
      },
      tooltip: {
        backgroundColor: "#1a1d1f",
        titleFont: { size: 12, weight: "600" },
        bodyFont: { size: 12 },
        padding: 10,
        cornerRadius: 8,
      },
    },
  };

  return (
    <div className="chart-card">
      <div className="chart-card-header">
        <div className="chart-card-title">
          <h3>Availability Ratio <Tooltip code="P3F4" /></h3>
          <p>Time slot distribution</p>
        </div>
      </div>
      <div className="filter-group" style={{ marginBottom: 16 }}>
        <DateRangePicker
          initialSettings={{
            startDate: moment(),
            endDate: moment().add(14, "d"),
            locale: { firstDay: 0 },
          }}
          onCallback={(start, end) => {
            setStartDate(moment(start).format("DD/MM/yyyy"));
            setEndDate(moment(end).format("DD/MM/yyyy"));
            loadChartData({
              event_id: eventId,
              start_date: moment(start).format("DD/MM/yyyy"),
              end_date: moment(end).format("DD/MM/yyyy"),
            });
          }}
        >
          <input type="text" className="form-control date-range-input" />
        </DateRangePicker>
        <div className="event-select">
          <Select
            size="large"
            placeholder="Select Event"
            allowClear={true}
            onChange={(value) => {
              setEventId(value);
              loadChartData({
                event_id: value,
                start_date: startDate,
                end_date: endDate,
              });
            }}
            style={{ width: "100%" }}
            value={eventId}
            options={props.events}
          />
        </div>
      </div>
      <div className="chart-card-body" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div className="pie-chart-wrapper">
          {renderChart && <Doughnut data={chartData} options={chartOptions} />}
        </div>
      </div>
    </div>
  );
};

export default connect(null, { sendPostRequest })(PieSalesChart);
